import React from 'react';
import { toDate, toFriendlyDateStringNoYear } from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';

class ReferralsMobile extends React.Component {
  render() {
    const referrals = this.props.referrals || [];
    return (
      <div className="mobile_card">
        {referrals.length === 0 && (
          <div id="mobile_card">
            <div className="row">
              <p
                style={{
                  textAlign: 'center',
                  color: 'rgba(0,0,0,0.5)',
                  marginTop: '13px',
                }}
              >
                No Referrals
              </p>
            </div>
          </div>
        )}

        {referrals.map((item, index) => this.renderReferralItem(item, index))}
      </div>
    );
  }

  renderStatus = status => {
    const statusColor = {
      applying: colors.YELLOW,
      converted: colors.GREEN,
      completed: colors.GREEN,
    };

    return (
      <div style={{ float: 'right', marginTop: '4px' }}>
        <span style={{ fontSize: '10px', color: 'grey', textTransform: 'capitalize' }}>
          <span
            style={{ color: statusColor[status], transition: 'all .3s ease', marginRight: '5px' }}
          >
            &#x25cf;
          </span>
          {status}
        </span>
      </div>
    );
  };

  renderReferralItem = (item, index) => {
    const referrer = item && item.referrer ? item.referrer : {};

    return (
      <div id="mobile_card" key={index} onClick={() => this.props.toggleDialog(item)}>
        <div className="row">
          {this.renderStatus(item.status)}
          <div className="mobile_header"> {item.unit_name}</div>
          <div className="mobile_subheader">
            {' '}
            {toFriendlyDateStringNoYear(toDate(item.date_applied))}{' '}
          </div>
          <div className="mobile_subheader">
            Referred by {referrer.name} - {referrer.unit_name}
          </div>
        </div>
      </div>
    );
  };
}

export default ReferralsMobile;
